import React from 'react';
import { useEffect } from 'react';

import { Link } from "react-router-dom";

function CSMTabs() {
    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }, []);
    return (

        <div className="additional-information">
            <div className="list">
                <ul className='text-start'>
                    <Link to="/dept/ai-ml" onclick="scrollWin()">
                        <li className="text-black">
                            <i class="fas fa-robot"></i> <span>About the Department</span>
                        </li>
                    </Link>
                    <Link to="/dept/csm/vision-mission" onclick="scrollWin()">
                        <li className="text-black">
                            <i class="fas fa-bullseye"></i> <span>Vision, Mission & PEO’s</span>
                        </li>
                    </Link>
                    <Link to="/dept/csm/po-and-pso" onclick="scrollWin()">
                        <li className="text-black">
                            <i class="fas fa-list-alt"></i> <span>PO and PSO’s</span>
                        </li>
                    </Link>
                    <Link to="/dept/csm/hod-profile" onclick="scrollWin()">
                        <li className="text-black">
                            <i class="fas fa-user-tie"></i> <span>HOD Profile</span>
                        </li>
                    </Link>
                    <Link to="/dept/csm/csm-faculty-list" onclick="scrollWin()">
                        <li className="text-black">
                            <i class="fas fa-chalkboard-teacher"></i> <span>Faculty List</span>
                        </li>
                    </Link>
                    <Link to="/dept/csm/csm-events-list" onclick="scrollWin()">
                        <li className="text-black">
                            <i class="fas fa-calendar-alt"></i> <span>Events</span>
                        </li>
                    </Link>
                    <Link to="/dept/csm/workshops">
                        <li className="text-black">
                            <i className="fas fa-tools"></i> <span>FDP/STTPs/Workshops</span>
                        </li>
                    </Link>
                    <Link to="/dept/csm/csm-academic-calendar" onclick="scrollWin()">
                        <li className="text-black">
                            <i class="fas fa-calendar"></i> <span>Academic Calendar</span>
                        </li>
                    </Link>
                    <Link to="/dept/csm/csm-syllabus" onclick="scrollWin()">
                        <li className="text-black">
                            <i class="fas fa-book"></i> <span>Syllabus</span>
                        </li>
                    </Link>
                    <Link to="/dept/csm/course-files" onclick="scrollWin()">
                        <li className="text-black">
                            <i class="fas fa-folder"></i> <span>Course Files</span>
                        </li>
                    </Link>
                    <Link to="/dept/csm/csm-industrial-visit" onclick="scrollWin()">
                        <li className="text-black">
                            <i class="fas fa-industry"></i> <span>Industrial Visit</span>
                        </li>
                    </Link>
                    <Link to="/dept/csm/laboratories" onclick="scrollWin()">

                        <li className="text-black">

                            <i className='fas fa-desktop'></i> <span>Laboratories </span>
                        </li>
                    </Link>
                    <Link to="/dept/csm/mou">
                        <li className="text-black">
                            <i className="fas fa-file-signature"></i> <span>MOU</span>
                        </li>
                    </Link>

                    {/* <Link to="/dept/csm/csm-publications" onclick="scrollWin()">
                        <li className="text-black">
                            <i class="fas fa-newspaper"></i> <span>Publications</span>
                        </li>
                    </Link> */}
                    <Link to="/dept/csm/result-analysis" onclick="scrollWin()">
                        <li className="text-black">
                            <i class="fas fa-chart-bar"></i> <span>Result Analysis</span>
                        </li>
                    </Link>

                </ul>
            </div>
        </div>
    )
}

export default CSMTabs;
